import { useEffect, useState } from "react";
import useAuth from "./useAuth";
import { BASE_URL } from "../_api";
import { menuGroups, menuItems } from "../menu-items/menu-config";

const useMenuItems = () => {
  const { user } = useAuth();
  const [groups, setGroups] = useState(null);
  const [items, setItems] = useState(null);
  const [drawerItems, setDrawerItems] = useState({ items: [] });

  useEffect(() => {
    if (user) {
      const fetchMenu = async () => {
        const token = localStorage.getItem("token");
        const response = await fetch(`${BASE_URL}/menu_items/`, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        });
        if (!response.ok) {
          console.error("SOMETHING WENT WRONG WHILE FETCHING MENU ITEMS");
          return;
        }
        const resData = await response.json();
        const groups = resData["groups"];
        const items = resData["items"];
        setGroups(groups);
        setItems(items);
      };
      fetchMenu();
    }
  }, [user]);

  useEffect(() => {
    // Loop through groups object, find which one to add based on true, false
    if (groups) {
      const newMenuItems = { items: [] };
      Object.keys(groups).map((groupKey) => {
        if (groups[groupKey]) {
          menuGroups.forEach((menuGroup) => {
            if (menuGroup.id === groupKey) {
              //   Loop throught items object
              const selectedGroup = { ...menuGroup };
              const selectedGroupChildren = [];
              if (items) {
                Object.keys(items).map((itemKey) => {
                  //   Check if value is true
                  if (
                    items[itemKey].value &&
                    items[itemKey].parent_group === selectedGroup.id
                  ) {
                    // Check if item does not have a collpase parent
                    if (!items[itemKey].is_collapse) {
                      selectedGroupChildren.push(menuItems[itemKey]);
                    } else {
                    }
                  }
                  return null;
                });
              }
              //   Set the group's children
              selectedGroup.children = selectedGroupChildren;
              //   Add the group to the menuItems
              newMenuItems["items"].push(selectedGroup);
            }
          });
        }
        return null;
      });
      setDrawerItems(newMenuItems);
    }
    // Reach out to the corresponding group object from menu-config menuGroups array based on id
  }, [groups, items]);

  return drawerItems;
};

export default useMenuItems;
